import { useState } from 'react';
import { useQuery } from '@apollo/client';
import { endOfDay, startOfDay } from 'date-fns';
import { CSVLink, Flex, StyledDatePicker, StyledFormSelect } from '..';
import { EXPORT_PORTAL_PROGRAMMES } from '../../../graphql';
import { formatSelectValue, getPortal } from '../../../utils';
import { getAllProgrammesQuery } from '../../../containers/shared/programmes/utils';

type Props = {
  programme: string;
};

type State = {
  programmeIds?: string[];
};

const headers = [
  { label: 'Programme ID', key: 'id' },
  { label: 'Programme', key: 'name' },
  { label: 'Summary', key: 'summary' },
  { label: 'Theory of Change', key: 'theoryOfChange' },
  { label: 'Start Date', key: 'fromDate' },
  { label: 'End Date', key: 'toDate' },
];

const ProgrammeExport = ({ programme }: Props) => {
  const [portal] = useState(getPortal());
  const [state, setState] = useState<State>({});
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);

  const { data: programmeData, error: programmeError, loading: programmeDataLoading } = useQuery(
    getAllProgrammesQuery(portal),
    {
      variables: {
        input: {
          isArchived: false,
          includeWhereReporter: true,
        },
      },
    }
  );
  const { data: exportData, loading: exportLoading } = useQuery(EXPORT_PORTAL_PROGRAMMES, {
    variables: {
      input: {
        ...(state.programmeIds && { programmeIds: state.programmeIds }),
        ...(startDate && { startDate: startOfDay(new Date(startDate)) }),
        ...(endDate && { endDate: endOfDay(new Date(endDate)) }),
      },
    },
  });

  return (
    <Flex size="1" direction="column">
      <Flex size="1" direction="row" marginRight="10px">
        <StyledFormSelect
          isMulti={true}
          isClearable={true}
          name="programmeIds"
          label="Programme"
          onChange={(option: any[]) =>
            setState(Object.assign({}, state, { [programme]: option.map(opt => opt.value) }))
          }
          options={
            programmeDataLoading || programmeError || !(programmeData && programmeData.programmes)
              ? []
              : programmeData.programmes.map((item: any) =>
                  formatSelectValue({
                    label: item.name,
                    value: item.id,
                  })
                )
          }
        />
      </Flex>
      <Flex size="1.2" direction="column">
        <StyledDatePicker
          label="Programme Date"
          name="programmeDate"
          setStartDate={setStartDate}
          setEndDate={setEndDate}
        />
      </Flex>
      {exportLoading ? (
        <div>Loading...</div>
      ) : (
        <Flex size="1" direction="row" marginRight="10px">
          {exportData && exportData.exportServiceProviderProgrammes && (
            <CSVLink headers={headers} data={exportData.exportServiceProviderProgrammes}>
              Export CSV
            </CSVLink>
          )}
        </Flex>
      )}
    </Flex>
  );
};

export default ProgrammeExport;
